import React, { memo } from 'react';

const TerminalContent = memo(({ activity }) => {
  const isTyping = activity?.action === 'type';
  const isExecuting = activity?.action === 'execute';
  
  return (
    <div className="flux-terminal-content">
      <div className="terminal-header">
        <span className="terminal-title">zsh — ~/projects/my-app</span>
      </div>
      
      <div className="terminal-output">
        <div className="terminal-line prompt">
          <span className="terminal-user">user@macbook</span>
          <span className="terminal-path">~/projects/my-app</span>
          <span className="terminal-symbol">$</span>
        </div>
        <div className="terminal-line command">npm run dev</div>
        
        <div className="terminal-line output success">
          <span className="terminal-check">✓</span> Build completed
        </div>
        
        <div className="terminal-line output">
          <span className="terminal-label">Local:</span>
          <span className="terminal-url">http://localhost:3000</span>
        </div>
        
        <div className="terminal-line output">
          <span className="terminal-label">Network:</span>
          <span className="terminal-url">http://192.168.1.42:3000</span>
        </div>
        
        <div className="terminal-line output dim">
          <span>ready - started server on 0.0.0.0:3000</span>
        </div>
        
        <div className="terminal-line output dim">
          <span>info  - Loaded env from .env.local</span>
        </div>
        
        <div className={`terminal-line output ${isExecuting ? 'executing' : ''}`}>
          <span className="terminal-time">15:42:18</span>
          <span className="terminal-event">GET</span>
          <span className="terminal-route">/api/users</span>
          <span className="terminal-status success">200</span>
          <span className="terminal-duration">124ms</span>
        </div>
        
        <div className="terminal-line output">
          <span className="terminal-time">15:42:22</span>
          <span className="terminal-event">POST</span>
          <span className="terminal-route">/api/auth/login</span>
          <span className="terminal-status success">200</span>
          <span className="terminal-duration">89ms</span>
        </div>
        
        <div className="terminal-line prompt">
          <span className="terminal-user">user@macbook</span>
          <span className="terminal-path">~/projects/my-app</span>
          <span className="terminal-symbol">$</span>
        </div>
        
        <div className={`terminal-line command ${isTyping ? 'typing' : ''}`}>
          {isTyping ? 'git add .' : 'git status'}
          {isTyping && <span className="terminal-cursor" />}
        </div>
      </div>
    </div>
  );
});

TerminalContent.displayName = 'TerminalContent';

export default TerminalContent;
